import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortUsers'
})
export class SortUsersPipe implements PipeTransform {

  transform(value: Array<any>, field: string): any {
    if(value == null || value.length <= 0) {
      return null;
    }
    if (field.startsWith("-")) {
      field = field.substring(1);

      return [...value].sort((a, b) => {
        if(field == 'name') {
          return b.name.full.first.localeCompare(a.name.full.first);
        } else if(field == 'active' || field == 'saw') {
          return b[field] - a[field];
        } else {
          return b[field].localeCompare(a[field]);
        }
      });
    }
    else {
      return [...value].sort((a, b) => {
        if(field == 'name') {
          return a.name.full.first.localeCompare(b.name.full.first);
        } else if(field == 'active' || field == 'saw') {
          return a[field] - b[field];
        } else {
          return a[field].localeCompare(b[field]);
        }
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/users/pipes/sort-users-pipe.ts